import type {ReactElement} from 'react';
import React from 'react';
import {BaseTintColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-tint-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetSelectedSlideId} from '@Hooks/poster-editor/useGetSelectedSlideId';
import {useGetKeyFromEffectsOfActiveSlideItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveSlideItem';
import type {RGBA} from '@Utils/color.util';

export function SlideitemTintColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId();
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeSlideUID = useGetSelectedSlideId();
  const tintColor = useGetKeyFromEffectsOfActiveSlideItem('tintColor');

  if (!activeItem || !activeSlideUID) {
    throw new Error('Active item or active slide is not defined in slideshow item effects options');
  }

  if (!activeItem.isSlideshow()) {
    throw new Error(`Expected active item to be of type slideshow, got ${activeItem.gitype} instead`);
  }

  if (!tintColor) {
    throw new Error('blackandwhite is undefined for active slide item');
  }

  const updateTintColor = (tintColor: RGBA, undoable = true): void => {
    void activeItem.updateSlideFromObject(
      activeSlideUID,
      {
        effects: {
          tintColor,
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseTintColorPanel tintColor={tintColor} onUpdateTintColor={updateTintColor} />;
}
